import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { GobiernoUser } from 'src/app/administrador/busqueda-usuario/interfaces/user.interface';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UsuarioService {
    private readonly _apiUrl = environment.apiSiriUrl;

    public constructor(private http: HttpClient) {}

    public registrarUsuario(keycloakSub: string): Observable<unknown> {
        return this.http.post<unknown>(`${this._apiUrl}usuario/registrar`, {
            keycloakSub,
        });
    }

    public getUsuario(usuarioID: number): Observable<GobiernoUser> {
        return this.http.get<GobiernoUser>(
            `${this._apiUrl}usuario/get-by-id/${usuarioID}`
        );
    }
}
